import { useLogout } from "@/api/app/login/useLogout";
import Logo from "@/components/Logo/Logo";
import toast from "@/lib/toast";
import Avatar from "@/src/app/(auth)/_components/Avatar";
import Logout from "@/src/app/(auth)/_components/Logout";
import Menu from "@/src/app/(auth)/_components/Menu/Menu";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function Navbar() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { trigger } = useLogout({
    onSuccess: (data) => {
      navigate("/app/login", { replace: true });
      toast.success(data.message);
    },
  });

  return (
    <div className="flex h-16 w-full justify-between pl-6 pr-2 shadow">
      <div className="flex h-full items-center gap-6">
        <Logo />
        <Menu />
      </div>
      <div className="flex h-full">
        <div className="flex h-full items-center gap-2 py-2 pl-2 pr-4">
          <Avatar />
        </div>
        <Logout
          onLogout={() => {
            if (window.confirm(t("logout-confirm"))) {
              toast.loading(t("logout-loading"));
              trigger();
            }
          }}
        />
      </div>
    </div>
  );
}

export default Navbar;